import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { siguiente, getCotizacion } from './reducer/todo-reducer';
import InputRange from 'react-input-range';
import Tipo from './Tipo';
import Cotizacion from './Cotizacion';



const userData = ['cmbEdad', 'edadHijo', 'monto', 'nombre', 'apellidos', 'correo', 'tTelefono', 'telefono'];
const strucReq = ['CIANNE', 'Fecha', 'Hora', 'Nombre', 'Apellidos', 'Email', 'phoneType', 'Telefono', 'EdadCont', 'Genero', 'Fumador', 'EdadHijo', 'MontoMensual', 'TipoCole'];
const noFuma = "NoFumador";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mensaje: {},
      habito: noFuma,
      genero: "Hombre",
      edadHijo: 8,
      cmbEdad: 49,
      monto: 15000,
      nombre: "",
      apellidos: "",
      correo: "",
      tTelefono: "",
      telefono: "",
      disabledUniversidad: false,
      tipo: "18",
      cotizacion: {
        "cotizacion": {
          "primaBasica": "80676.0",
          "primaBeneficios": "3780.0",
          "edadCotizacion": "49",
          "coberturas": {
            "coberturas": [
              {
                "cobertura": "",
                "sumaAsegurada": "",
                "prima": ""
              },
              {
                "cobertura": "0000001076",
                "sumaAsegurada": "900000.0",
                "prima": "126.0"
              },
              {
                "cobertura": "0000001393",
                "sumaAsegurada": "900000.0",
                "prima": "657.0"
              },
              {
                "cobertura": "0000001394",
                "sumaAsegurada": "900000.0",
                "prima": "2997.0"
              }
            ]
          },
          "primaTotal": "8458.93125"
        },
        "ahorroGarantizado": 900000
      },
      loading: false
    }
  }
  componentWillReceiveProps(nextProps) {

    if (nextProps.successCotizacion) {
      console.log(nextProps.successCotizacion);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.edadHijo !== this.state.edadHijo) {

      if (this.state.edadHijo >= 12) {
        this.setState({ disabledUniversidad: true });
        this.setState({ tipo: "23" })
      } else {
        this.setState({ disabledUniversidad: false });
      }
    }
  }

  componentDidMount() {
    var options = [];

    for (var i = 18; i <= 69; i++) {
      options.push(i);
    }

    this.setState({ optionsAge: options });



  }

  render() {
    if (this.props.successCotizacion) {
      return <Cotizacion cotizacion={this.props.successCotizacion} />
    }
    return (
      <React.Fragment>
        <div style={{ maxWidth: "780px", maxHeight: "1000px", margin: "auto auto" }}>

          <div className="backCotizadorEducacion hidden-xs" >
            <div className="divTituloEducacion">
              <label className="iconoCotDesktop" />
              <label className="requiredIn labelTituloDesktop" >Asegura la colegiatura de tus hijos</label>
            </div>

            <div className="divTuInfo">
              <div className="divTituloDivicion">
                Tus datos
          </div>

              <div className="formulario-datoscte" style={{ maxWidth: "820px" }}>
                <div className="contenidoFormularioDesktop hidden-xs">
                  <div className="col-md-10 col-sm-8 col-xs-8 contenidoDesktop">
                    <br />
                    <div className="col-md-9 col-sm-9 col-xs-9">
                      <div className="col-md-6 col-sm-6 col-xs-6">
                        <div className="form-group">
                          <label htmlFor="nombre">Nombre(s) <span className="requiredIn">*</span></label>
                          <input type="text" maxLength="250" className="form-control" id="nombre" name="nombre"
                            value={this.state.nombre ? this.state.nombre : ""}
                            onChange={this.changeValues.bind(this)} />
                          {
                            this.state.mensaje ?
                              this.state.mensaje.nombre ? <p className="errorMsj">{this.state.mensaje.nombre}</p> : null
                              : null
                          }

                        </div>
                      </div>

                      <div className="col-md-6 col-sm-6 col-xs-6">
                        <div className="form-group">
                          <label htmlFor="apellidos">Apellidos <span className="requiredIn">*</span></label>
                          <input type="text" maxLength="250" className="form-control" id="apellidos" name="apellidos"
                            value={this.state.apellidos ? this.state.apellidos : ""}
                            onChange={this.changeValues.bind(this)} />
                          {
                            this.state.mensaje ?
                              this.state.mensaje.apellidos ? <p className="errorMsj">{this.state.mensaje.apellidos}</p> : null
                              : null
                          }

                        </div>
                      </div>
                    </div>

                    <div className="col-md-8 col-sm-8 col-xs-8">
                      <div className="col-md-8 col-sm-8 col-xs-8">
                        <div className="form-group">
                          <label htmlFor="correo">Correo Electrónico <span className="requiredIn">*</span></label>
                          <input type="text" maxLength="250" className="form-control" id="correo" name="correo"
                            value={this.state.correo ? this.state.correo : ""}
                            onChange={this.changeValues.bind(this)} />
                          {
                            this.state.mensaje ?
                              this.state.mensaje.correo ? <p className="errorMsj">{this.state.mensaje.correo}</p> : null
                              : null
                          }

                        </div>
                      </div>
                    </div>

                    <div className="col-md-11 col-sm-11 col-xs-11">

                      <div className="col-md-4 col-sm-4 col-xs-4">
                        <div className="form-group">
                          <label htmlFor="tTelefono">Tipo de Teléfono <span className="requiredIn">*</span></label>
                          <select id="tTelefono" name="tTelefono" value={this.state.tTelefono ? this.state.tTelefono : ""}
                            onChange={this.changeValues.bind(this)} className="form-control">
                            <option value=""></option>
                            <option value="celular">Celular</option>
                            <option value="fijo">Fijo</option>
                          </select>
                          {
                            this.state.mensaje ?
                              this.state.mensaje.tTelefono ? <p className="errorMsj">{this.state.mensaje.tTelefono}</p> : null
                              : null
                          }

                        </div>
                      </div>
                      <div className="col-md-7 col-sm-7 col-xs-7">
                        <div className="form-group">
                          <label htmlFor="telefono">Teléfono (10 dígitos) <span className="requiredIn">*</span></label>
                          <input type="text" maxLength="10" className="form-control" id="telefono" name="telefono"
                            value={this.state.telefono ? this.state.telefono : ""}
                            onChange={this.changeValues.bind(this)} />
                          {
                            this.state.mensaje ?
                              this.state.mensaje.telefono ? <p className="errorMsj">{this.state.mensaje.telefono}</p> : null
                              : null
                          }

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                </div>
              </div>
              <div className="DivSkipPage"></div>



              <div className="DivEdadP">
                Edad
          </div>


              <div className="rangoEdad">
                <InputRange
                  maxValue={70}
                  minValue={18}
                  formatLabel={value => ``}
                  value={this.state.cmbEdad}
                  onChange={cmbEdad => this.setState({ cmbEdad })}
                  onChangeComplete={cmbEdad => console.log(cmbEdad)} />

              </div>

              <div className="edadResultRango">
                {this.state.cmbEdad} Años
          </div>

              <div className="subRangoEdadMin">
                18 Años
          </div>

              <div className="subRangoEdadMax">
                70 Años
          </div>

              <div className="DivGenero">
                <div>Género</div>
              </div>

              <div className="DivFumas">
                <div>¿Fumas?</div>
              </div>

              <div className="radioDivGenero">
                <div><label><input type="radio" name="generoDesk" value="Hombre"
                  checked={this.state.genero === "Hombre"} onChange={this.changeValues.bind(this)} /> Masculino</label>&nbsp;&nbsp;
            <label><input type="radio"
                    name="generoDesk" value="Mujer"
                    checked={this.state.genero === "Mujer"} onChange={this.changeValues.bind(this)} /> Femenino</label></div>
              </div>

              <div className="radioDivFumas">
                <div><label><input type="radio"
                  name="habitoDesk" value="Fumador"
                  checked={this.state.habito === "Fumador"} onChange={this.changeValues.bind(this)} /> Sí</label>&nbsp;&nbsp;
            <label><input type="radio"
                    name="habitoDesk" value="noFumador"
                    checked={this.state.habito === noFuma} onChange={this.changeValues.bind(this)} /> No</label></div>
              </div>
            </div>

            <div className="divTuHijoDesk">
              <div className="divTituloDivicion">
                Tu hijo(a)
            </div>

              <div className="DivEdadH">
                Edad
            </div>

              <div className="rangoEdadHijo">
                <InputRange
                  maxValue={16}
                  minValue={0}
                  formatLabel={value => ``}
                  value={this.state.edadHijo}
                  onChange={edadHijo => this.setState({ edadHijo })}
                  onChangeComplete={edadHijo => console.log(edadHijo)}
                />

              </div>


              <div className="edadResultRango">
                {this.state.edadHijo} Años
            </div>

              <div className="subRangoEdadMin">
                0 Años
            </div>

              <div className="subRangoEdadMax">
                16 Años
            </div>

              <div className="DivMonto">
                ¿Qué monto mensual deseas garantizar para tu hij@?
            </div>

              <div className="rangoMonto">
                <InputRange
                  maxValue={30000}
                  minValue={1000}
                  step={1000}
                  formatLabel={value => ``}
                  value={this.state.monto}
                  onChange={monto => this.setState({ monto })}
                  onChangeComplete={monto => console.log(monto)} />

              </div>

              <div className="ResultMonto">
                ${this.formato(this.state.monto)} <br />
                <p>Pesos Mexicanos </p>
              </div>

              <div className="subRangoMontoMin">
                $1,000
            </div>

              <div className="subRangoMontoMax">
                $30,000
            </div>
            </div>







            <div className="divTuHijoDesk">
              <div className="divTituloDivicion">
                Te gustaría generar un ahorro para apoyarlo en:
            </div>


              <div className="contenidoFormularioTipo">





                <div className="tipoAhorro col-xs-12">
                  <div className="col-xs-6 text-center">
                    <label className="uniResponsive" ></label>
                    <br />
                    <input type="radio" name="tipo" id="tipo" value="18" className="browser-default"
                      onChange={this.changeValues.bind(this)} checked={this.state.tipo === "18"}
                      disabled={this.state.disabledUniversidad}
                    /> <label>Universidad</label>
                    <div className="descripcionTipo">
                      (18 años)
                                </div>
                  </div>
                  <div className="col-xs-6 text-center">
                    <label className="maestResponsive" ></label>
                    <br />
                    <input type="radio" name="tipo" id="tipo" value="23" className="browser-default"
                      onChange={this.changeValues.bind(this)} checked={this.state.tipo === "23"}

                    /> <label>Maestría</label>
                    <div className="descripcionTipo">
                      (23 años)
                                </div>
                  </div>

                </div>



              </div>

            </div>


          </div>








          <div className="col-xs-12 hidden-xs text-right" style={{ maxWidth: "780px", marginTop: "10px", paddingRight: "23px" }}>
            <button className="btn btn-gnp" onClick={this.cotizar.bind(this)}
              style={{ display: "block", margin: "0 auto", marginTop: "5px", marginBottom: "3px" }} >Continuar</button>
          </div>

          <div className="formulario-cotiza hidden-md hidden-sm hidden-lg">
            <div className="titulo">
              <label className="iconoCotResponsive" />
              <label>Asegura la colegiatura de tu hijos</label>
            </div>
            <div className="contenidoFormulario">
              <div className="col-xs-12 text-center">
                <div className="col-xs-12 tituloEducacion">
                  Tus Datos
              </div>
              </div>
              <div className="col-xs-12" style={{ marginTop: "20px" }}>
                <div className="col-xs-6">
                  <div className="form-group">
                    <label htmlFor="cmbEdad">Edad <span className="requiredIn">*</span></label>
                    <select className="form-control"
                      value={this.state.cmbEdad}
                      id="cmbEdad" name="cmbEdad" onChange={this.changeValues.bind(this)}>
                      {
                        this.state.optionsAge ? (
                          this.state.optionsAge.map(function (value, index) {
                            return <option value={value + 1} key={index}>{value + 1}</option>
                          })
                        ) : null
                      }
                    </select>

                    {
                      this.state.mensaje ?
                        this.state.mensaje.cmbEdad ? <p className="errorMsj">{this.state.mensaje.cmbEdad}</p> : null
                        : null
                    }
                  </div>
                </div>
                <div className="col-xs-6">

                  <label htmlFor="cmbEdad">Genero <span className="requiredIn">*</span></label>

                  <div className="form-group">

                    <label>
                      <input type="radio" name="genero" id="genero" value="Hombre"
                        checked={this.state.genero === "Hombre"} onChange={this.changeValues.bind(this)} />
                            &nbsp;Masculino
                        </label>&nbsp;
                        <label>
                      <input type="radio" name="genero" id="genero" value="Mujer"
                        checked={this.state.genero === "Mujer"} onChange={this.changeValues.bind(this)} />
                            &nbsp;Femenino
                        </label>
                  </div>
                </div>
              </div>

              <div className="col-xs-12">
                <div className="col-xs-12">
                  <label>¿Fumas?</label>
                </div>
                <div className="col-xs-12">
                  <label>
                    <input type="radio" name="habito" id="habito" value="Fumador"
                      checked={this.state.habito === "Fumador"} onChange={this.changeValues.bind(this)} />
                    &nbsp;Sí
                </label>&nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                    <input type="radio" name="habito" id="habito" value="NoFumador"
                      checked={this.state.habito === noFuma} onChange={this.changeValues.bind(this)} />
                    No
                </label>
                </div>
              </div>
              <div className="col-xs-12 text-center" style={{ marginTop: "10px" }}>
                <div className="col-xs-12 tituloEducacion">
                  Tu Hijo(a)
              </div>
              </div>
              <div className="col-xs-12" style={{ marginTop: "20px" }}>
                <div className="col-xs-6">
                  <div className="form-group edadHijo">
                    <label htmlFor="edadHijo">Edad <span className="requiredIn">*</span></label>
                    <select className="form-control" id="edadHijo"
                      value={this.state.edadHijo}
                      name="edadHijo" onChange={this.changeValues.bind(this)}>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                    </select>
                    {
                      this.state.mensaje ?
                        this.state.mensaje.edadHijo ? <p className="errorMsj">{this.state.mensaje.edadHijo}</p> : null
                        : null
                    }
                  </div>
                </div>
                <div className="col-xs-6">
                  <div className="form-group">
                    <label htmlFor="monto">¿Qué monto mensual deseas garantizar para tu hij@? <span className="requiredIn">*</span></label>
                    {}

                    <select className="form-control" id="monto"
                      value={this.state.monto}
                      name="monto" onChange={this.changeValues.bind(this)}>
                      <option value="1000">$1,000</option>
                      <option value="2000">$2,000</option>
                      <option value="3000">$3,000</option>
                      <option value="4000">$4,000</option>
                      <option value="5000">$5,000</option>
                      <option value="6000">$6,000</option>
                      <option value="7000">$7,000</option>
                      <option value="8000">$8,000</option>
                      <option value="9000">$9,000</option>
                      <option value="10000">$10,000</option>
                      <option value="11000">$11,000</option>
                      <option value="12000">$12,000</option>
                      <option value="13000">$13,000</option>
                      <option value="14000">$14,000</option>
                      <option value="15000">$15,000</option>
                      <option value="16000">$16,000</option>
                      <option value="17000">$17,000</option>
                      <option value="18000">$18,000</option>
                      <option value="19000">$19,000</option>
                      <option value="20000">$20,000</option>
                      <option value="21000">$21,000</option>
                      <option value="22000">$22,000</option>
                      <option value="23000">$23,000</option>
                      <option value="24000">$24,000</option>
                      <option value="25000">$25,000</option>
                      <option value="26000">$26,000</option>
                      <option value="27000">$27,000</option>
                      <option value="28000">$28,000</option>
                      <option value="29000">$29,000</option>
                      <option value="30000">$30,000</option>
                    </select>

                  </div>
                </div>
              </div>

              <div className="col-xs-12">
                <div className="col-xs-12 text-right">
                  <button className="btn btn-gnp" onClick={this.cotizar.bind(this)}>Cotizar </button>
                </div>
              </div>


            </div>
          </div>
          {
            this.state.loading ?
              <div className="gnp-loading">
                <div className="circle-orange"></div>
                <div className="circle-blue"></div>
                <div className="logo"><img src="https://storage.googleapis.com/static-portalcorporativo.gnp.com.mx/images/site/logo_header @1x.svg"
                  className="fr-fic fr-dib" /></div>
              </div>
              : null
          }
        </div>
      </React.Fragment>
    );
  }


  changeValues(event) {
    var mensaje = this.state.mensaje;
    var name = event.target.name;
    var value = event.target.value;

    if (name === "generoDesk") {
      name = "genero";
    } else if (name === "habitoDesk") {
      name = "habito";
    }

    mensaje[name] = null;

    this.setState({ [name]: value, mensaje });
  }


  formato(cantidad) {
    return Math.floor(cantidad).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  cotizar(event) {
    var mensaje = this.state.mensaje;
    var valido = true;

    for (var i = 0; i < userData.length; i++) {
      var re;
      var plural = false;
      var msjToShow = null;
      if (i === 1) {
        this.state[userData[i]] = "" + this.state[userData[i]];
      }
      if (!this.state[userData[i]]) {
        mensaje[userData[i]] = "Campo requerido.";
        valido = false;
      } else if (this.state[userData[i]].toString().trim() === "") {
        mensaje[userData[i]] = "Campo requerido.";
        valido = false;
      } else {
        console.log("ELSE");
        switch (userData[i]) {
          case 'correo':
            re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            msjToShow = "un correo válido."
            break;
          case 'telefono':
            re = /^\d{10}$/;
            msjToShow = "un teléfono válido.";
            break;
          case 'apellidos':
            re = /^[a-z\u00E0-\u00FC ]+$/i;
            msjToShow = "apellidos válidos.";
            break;
          case 'nombre':
            re = /^[a-z\u00E0-\u00FC ]+$/i;
            msjToShow = "un nombre válido.";
            break;
          default:
            console.log(userData[i])
            re = null;
        }

        if (re) {
          if (!re.test(this.state[userData[i]])) {
            if (plural) {
              mensaje[userData[i]] = "Capture " + msjToShow + " válidos.";
            } else {
              mensaje[userData[i]] = "Capture " + (msjToShow ? msjToShow : userData[i]);
            }
            valido = false;
          }
        }
      }
    }
    if (this.state.monto) {

      if (this.state.monto % 1000 === 0) {
        if (this.state.monto < 1000 || this.state.monto > 30000) {
          mensaje.monto = "Ingrese un monto mensual válido";
          valido = false;
        }
      } else {
        mensaje.monto = "Ingrese solo multiplos de mil";
        valido = false;
      }
    }

    this.setState({ mensaje });
    console.log("this.props.valores" + this.props.valores);
    console.log("this.state" + this.state);

    var values = {
      edadApoyo: this.state.tipo,
      paso1: {
        nombre: this.state.nombre,
        apellido: this.state.apellidos,
        correo: this.state.correo,
        tTelefono: this.state.tTelefono,
        telefono: this.state.telefono,
        edadHijo: this.state.edadHijo,
        montoMensual: this.state.monto,
        edad: this.state.cmbEdad,
        genero: this.state.genero,
        habito: this.state.habito
      }
    }



    if (valido) {
      this.setState({ loading: true });
      console.log("loading" + this.state.loading);

      this.props.actions.getCotizacion(values);
      enviaDoc(this.state);
    }

  }

}

const enviaDoc = async (state) => {

  const ordenUD = [3, 4, 5, 6, 7, 0, 1, 2];
  const ordenSR = [3, 4, 5, 6, 7, 8, 11, 12];
  var dataString = '"' + strucReq[0] + '":"123654",';
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var yyyy = today.getFullYear();
  var h = String(today.getHours());
  var m = String(today.getMinutes());
  var s = String(today.getSeconds());

  today = dd + '/' + mm + '/' + yyyy;

  const hour = h + ":" + m + ":" + s;
  dataString = dataString + '"' + strucReq[1] + '":"' + today.toString() + '",';
  dataString = dataString + '"' + strucReq[2] + '":"' + hour.toString() + '",';

  for (var i = 0; i < userData.length; i++) {
    console.log(state[userData[ordenUD[i]]]);
    dataString = dataString + '"' + strucReq[ordenSR[i]] + '":"' + state[userData[ordenUD[i]]] + '",';
  }

  dataString = dataString + '"' + strucReq[9] + '":"' + state["genero"] + '",';
  dataString = dataString + '"' + strucReq[10] + '":"' + state["habito"] + '",';
  dataString = dataString + '"' + strucReq[13] + '":"' + "licenciatura" + '"';

  dataString = '{' + dataString + '}'

  const options = {
    url: 'https://us-central1-gnp-portalcorporativo-qa.cloudfunctions.net/updateDocSheet',
    mode: 'no-cors',
    method: 'POST',
    headers: {
      'Content-Type': 'application/octet-stream',
      'Access-Control-Allow-Origin': true
    },
    data: dataString
  }
  await fetch(options.url, {
    mode: options.mode,
    method: options.method,
    headers: options.headers,
    body: options.data
  }).then((response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }
  )
    .then(function (response) {
      console.log("Se agrego el registro al archivo");
    }).catch(function (error) {
      console.log(error);
    });

}

const mapStateToProps = (state) => {
  return {
    successCotizacion: state.educacionReducer.get("successCotizacion")
  };
}


const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ siguiente: siguiente, getCotizacion: getCotizacion }, dispatch)
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js